import { Button, DatePicker, Tabs } from "antd";
import React, { useState } from "react";
import { useStore } from "../context/StoreContext";
import EodReport from "../components/reports/EodReport";
import ReportService from "../services/reports.service";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { saveAsFile } from "../utils/helpers";
import InvoiceByServiceReportComponent from "../components/reports/InvoiceByServiceReport";
import ComprehensiveReportPage from "./ComprehensiveReport";

const Reports = () => {
  const { selectedStore } = useStore();
  const [date, setDate] = useState({
    from: dayjs().startOf("date").toISOString(),
    to: dayjs().endOf("date").toISOString(),
  });

  const downloadEodReport = async () => {
    try {
      const res = await ReportService.downloadEodReport(date.from, date.to);
      saveAsFile(
        res,
        `EOD Report ${dayjs(date.from).format("DD/MM/YYYY")}.csv`,
        "text/csv;charset=utf-8"
      );
    } catch (err) {
      toast.error("Error downloading report");
    }
  };

  return (
    <div>
      <div className="flex justify-between mb-3">
        <h1 className="text-xl font-bold">EOD Report</h1>
        {selectedStore ? (
          <p>
            Showing reports for the store:{" "}
            <strong>{selectedStore?.name}</strong>
          </p>
        ) : (
          <p>Showing reports for all the stores</p>
        )}
      </div>

      <div className="mb-3">
        <DatePicker
          className="mr-3"
          defaultValue={dayjs(date.from)}
          onChange={(value) => {
            if (value) {
              setDate({
                from: value.startOf("date").toISOString(),
                to: value.endOf("date").toISOString(),
              });
            } else {
              setDate({ from: "", to: "" });
            }
          }}
        />
        <Button color="green" variant="solid" onClick={downloadEodReport}>
          Download
        </Button>
      </div>

      <EodReport from={date.from} to={date.to} />
    </div>
  );
};

export default Reports;
